import React, { useState } from "react";
import Call from "../../assets/call.svg";
import Map from "../../assets/map.svg";
import Mail from "../../assets/email.svg";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    // Add your form submission logic here
  };

  return (
    <div className="w-full px-4 sm:px-6 md:px-8">
      <div className="max-w-6xl border bg-[#5032ff1a] border-[#fff3] rounded-[20px] sm:rounded-[30px] p-4 sm:p-6 md:p-12 lg:p-20 mx-auto my-8 md:my-16 lg:mb-32">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">
          {/* Left Section - Contact Details */}
          <div className="w-full lg:w-1/2 border-b lg:border-b-0 lg:border-r border-[#fff3] pb-8 lg:pb-0 lg:pr-10">
            <h2 className="text-xl sm:text-2xl font-bold">
              <span className="text-white">Get in </span>
              <span className="text-green-500">Touch</span>
              <span className="text-white"> with Us!</span>
            </h2>

            <div className="mt-6 sm:mt-8 space-y-4 sm:space-y-6">
              {/*  Office */}
              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full  flex items-center justify-center flex-shrink-0">
                  <img src={Map} alt="" />
                </div>
                <div>
                  <h3 className="text-white font-medium text-md sm:text-[20px] mb-[10px]">
                    Office
                  </h3>
                  <p className="text-white text-sm sm:text-md">
                    C7, 3RD FLOOR, SHRI RAM NAGAR, PHASE-I, RAIPUR,
                    CHHATTISGARH, INDIA, 492001
                  </p>
                </div>
              </div>

              {/* Email Id */}
              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full  flex items-center justify-center flex-shrink-0">
                  <img src={Mail} alt="" />
                </div>
                <div>
                  <h3 className="text-white font-medium text-md sm:text-[20px] mb-[10px]">
                    Email Id
                  </h3>
                  <p className="text-white text-sm sm:text-md break-words">
                    support@multiflysolution.com
                  </p>
                </div>
              </div>

              {/* Mobile Number */}
              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full  flex items-center justify-center flex-shrink-0">
                  <img src={Call} alt="" />
                </div>
                <div>
                  <h3 className="text-white font-medium text-md sm:text-[20px] mb-[10px]">
                    Mobile Number
                  </h3>
                  <p className="text-white text-sm sm:text-md">1800-309-6246</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Section - Contact Form */}
          <div className="w-full lg:w-1/2 pt-6 lg:pt-0">
            <div className="mb-4 sm:mb-6">
              <h2 className="text-xl sm:text-2xl font-bold">
                <span className="text-white">Contact </span>
                <span className="text-green-500">Form</span>
              </h2>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-3 sm:mb-4">
                {/* First Name */}
                <div>
                  <label className="block text-white text-xs sm:text-sm mb-1">
                    First Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="Enter Your First Name"
                    className="w-full p-2 rounded text-sm border border-gray-300"
                    required
                  />
                </div>

                {/* Last Name */}
                <div>
                  <label className="block text-white text-xs sm:text-sm mb-1">
                    Last Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder="Enter Your Last Name"
                    className="w-full p-2 rounded text-sm border border-gray-300"
                    required
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-3 sm:mb-4">
                {/* Email */}
                <div>
                  <label className="block text-white text-xs sm:text-sm mb-1">
                    Email <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter Your Email"
                    className="w-full p-2 rounded text-sm border border-gray-300"
                    required
                  />
                </div>

                {/* Mobile Number */}
                <div>
                  <label className="block text-white text-xs sm:text-sm mb-1">
                    Mobile Number <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="tel"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    placeholder="Enter Your Number"
                    className="w-full p-2 rounded text-sm border border-gray-300"
                    required
                  />
                </div>
              </div>

              {/* Message */}
              <div className="mb-4 sm:mb-6">
                <label className="block text-white text-xs sm:text-sm mb-1">
                  Message <span className="text-red-500">*</span>
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Write Your Message......"
                  className="w-full p-2 rounded text-sm border border-gray-300 h-24 sm:h-32"
                  required
                ></textarea>
              </div>

              {/* Submit Button */}
              <div className="flex flex-start">
                <button
                  type="submit"
                  className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 sm:px-10 rounded-full text-sm"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
